import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "manager-resident-create-drawer__close-trigger" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

import { computed, nextTick, reactive, ref, watch } from 'vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import type { FormInstance, Rule } from 'ant-design-vue/es/form';
import {
  Col as ACol,
  Drawer as ADrawer,
  Form as AForm,
  FormItem as AFormItem,
  Input as AInput,
  Row as ARow,
  Select as ASelect,
  Space as ASpace,
} from 'ant-design-vue';
import {
  showStcErrorNotification,
  showStcSuccessNotification,
} from '@/js/components/stc-notification';
import { createManagerResident } from './manager-residents-api';
import type { ManagerResidentsClusterOption, ManagerResidentStatusOption } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateResidentDrawer',
  props: {
    open: { type: Boolean },
    clusters: {},
    statusOptions: {}
  },
  emits: ["update:open", "created"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const formRef = ref<FormInstance>();
const submitting = ref(false);

const form = reactive({
  name: '',
  cluster: '',
  email: '',
  inn: '',
  status: '',
});

const rules: Record<string, Rule[]> = {
  name: [{ required: true, message: 'Введите название', whitespace: true }],
  cluster: [{ required: true, message: 'Выберите кластер' }],
  email: [{ required: true, message: 'Введите e-mail', type: 'email' }],
  inn: [{ required: true, message: 'Введите ИНН', whitespace: true }],
};

const clusterOptions = computed(() =>
  props.clusters.map((item) => ({
    value: item.id,
    label: item.name,
  })),
);

const statusSelectOptions = computed(() =>
  props.statusOptions.map((item) => ({
    value: item.id,
    label: item.name,
  })),
);

const isSaveDisabled = computed(
  () =>
    submitting.value ||
    !form.name.trim() ||
    !form.cluster ||
    !form.email.trim() ||
    !form.inn.trim(),
);

watch(
  () => props.open,
  (value) => {
    if (!value) return;
    if (!form.status && statusSelectOptions.value.length) {
      form.status = String(statusSelectOptions.value[0].value);
    }
  },
);

function resetForm(): void {
  form.name = '';
  form.cluster = '';
  form.email = '';
  form.inn = '';
  form.status = statusSelectOptions.value.length ? String(statusSelectOptions.value[0].value) : '';
  nextTick(() => {
    formRef.value?.clearValidate();
  });
}

function handleClose(): void {
  emit('update:open', false);
  resetForm();
}

async function handleSubmit(): Promise<void> {
  if (!formRef.value) return;

  try {
    await formRef.value.validate();
  } catch {
    return;
  }

  submitting.value = true;
  try {
    const msg = await createManagerResident({
      name: form.name.trim(),
      cluster: String(form.cluster),
      email: form.email.trim(),
      inn: form.inn.trim(),
      status:
        form.status ||
        (statusSelectOptions.value[0]?.value
          ? String(statusSelectOptions.value[0].value)
          : 'draft'),
    });
    showStcSuccessNotification(msg || 'Резидент успешно сохранён');
    emit('created');
    handleClose();
  } catch (error) {
    showStcErrorNotification(
      error instanceof Error ? error.message : 'Не удалось создать резидента',
    );
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ADrawer), {
    width: 800,
    open: __props.open,
    class: "manager-resident-create-drawer",
    "header-style": { padding: '32px 40px' },
    "body-style": { padding: '40px' },
    "footer-style": { textAlign: 'left', padding: '20px 40px 40px 40px' },
    onClose: handleClose
  }, {
    title: _withCtx(() => [...(_cache[5] || (_cache[5] = [
      _createElementVNode("span", { class: "manager-resident-create-drawer__title" }, "Добавление Резидента", -1)
    ]))]),
    closeIcon: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_unref(CloseOutlined))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(ARow), {
        align: "middle",
        justify: "end",
        class: "company-editing-drawer__toolbar"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ACol), null, {
            default: _withCtx(() => [
              _createVNode(_unref(ASpace), null, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline btn-medium",
                    disabled: submitting.value,
                    onClick: handleClose
                  }, " Отмена ", 8, _hoisted_2),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-medium",
                    disabled: isSaveDisabled.value,
                    onClick: handleSubmit
                  }, _toDisplayString(submitting.value ? 'Сохранение...' : 'Создать'), 9, _hoisted_3)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(AForm), {
        ref_key: "formRef",
        ref: formRef,
        layout: "vertical",
        model: form,
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AFormItem), {
            class: "stc-ant-field-skin",
            label: "Название",
            name: "name",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(AInput), {
                value: form.name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
                placeholder: "Название компании"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(AFormItem), {
            class: "stc-ant-field-skin",
            label: "Кластер",
            name: "cluster",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ASelect), {
                value: form.cluster,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.cluster) = $event)),
                placeholder: "Выберите кластер",
                options: clusterOptions.value
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_unref(AFormItem), {
            class: "stc-ant-field-skin",
            label: "Email",
            name: "email",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(AInput), {
                value: form.email,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.email) = $event)),
                placeholder: "company@example.com"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(AFormItem), {
            class: "stc-ant-field-skin",
            label: "ИНН",
            name: "inn",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(AInput), {
                value: form.inn,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.inn) = $event)),
                placeholder: "0987654321"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          (statusSelectOptions.value.length)
            ? (_openBlock(), _createBlock(_unref(AFormItem), {
                key: 0,
                class: "stc-ant-field-skin",
                label: "Статус",
                name: "status"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ASelect), {
                    value: form.status,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.status) = $event)),
                    options: statusSelectOptions.value
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})